import { EmailOptInDialog } from './emailOptInDialog';

const props = [];

export const EmailOptInDialogDirective = reactDirective => reactDirective(EmailOptInDialog, props);
EmailOptInDialogDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('emailOptInDialog', EmailOptInDialogDirective);
